import type { FilterState } from "../slices/filtersSlice";
import type { ProfileListState } from "../slices/profileListSlice";
import type { RepTop30State } from "../slices/repTop30Slice";
import type { RootState } from "../store";

export const profileListSelectedSelector = (
  state: RootState
): ProfileListState["selected"] => state.profileList.selected;

export const filtersSelector = (state: RootState): FilterState["category"] =>
  state.filter.category;

export const isUnauthorizedSelector = (state: RootState): boolean =>
  state.userData.isUnauthorized;

export const selectedRepSelector = (
  state: RootState
): RepTop30State["selectedRep"] => state.repTop30.selectedRep;

export const selectedCategoryIdSelector = (state: RootState): string | null =>
  state.opportunity.selectedCategoryId;

export const selectedSubcategorySelector = (state: RootState): string | null =>
  state.opportunity.selectedSubcategory;
